import React from 'react'
import Footer from './Components/Footer'
import Header from './Components/Header'
import { UnAuthModal } from '../reuseable/UnAuthModal'
import secureLocalStorage from 'react-secure-storage'

const About = () => {
  const authModal = secureLocalStorage.getItem('authModal')
    if (authModal) {
      return <UnAuthModal    />;
    }
  return (
    <div>
      <div>
        <Header />
      </div>
      {/* 
      <div className="inner-image-header">
        <div className="inner-image-text-about">
        <h1 className='heading-about'> About Us</h1>
          <p>
            Coming Soon
          </p>
        </div>
      </div> */}
      <div className="container">
        <div style={{ height: '100vh', marginTop: '80px' }}>
          <h1>About Us</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod nulla eget nibh commodo, eu blandit justo dictum. Maecenas id luctus eros. Fusce commodo pharetra justo, eget ultrices nulla commodo vitae. Maecenas rutrum mauris et odio tristique, a convallis velit pharetra. Integer in magna nec nibh bibendum commodo. Donec auctor libero a est faucibus, vel lacinia tellus fringilla. Nulla in nunc sed justo malesuada rhoncus. In eu commodo velit.
          </p>
          <p>
            Quisque varius ex non magna mattis, non commodo mi rhoncus. Nullam malesuada nisl nec ipsum venenatis, eu commodo neque lobortis. Maecenas eu ante et leo semper laoreet sit amet eget velit. Praesent ut malesuada ex. Vestibulum vel nisi mauris. Vestibulum non ipsum lorem. Sed vel lacus at tellus mollis volutpat. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Sed efficitur ultrices metus, eu porttitor massa consequat vel. Duis eget semper est. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam commodo justo nec molestie posuere.
          </p>
          <p>
            Duis ultricies turpis ac ipsum semper, eget elementum libero rutrum. Vivamus maximus quam sit amet mauris rhoncus, non luctus justo tempor. Nullam sagittis commodo augue, sed lacinia est vulputate at. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nulla facilisi. Nullam convallis nibh vitae tellus tristique blandit. Nunc eu enim mi. Nulla faucibus enim vel urna vehicula, id ullamcorper ipsum finibus. Nulla sodales neque in erat euismod, eu malesuada sapien accumsan. Duis vulputate augue non tellus mollis, non bibendum dolor feugiat. Aliquam laoreet justo nunc, vel blandit velit efficitur at. Sed ornare interdum ultrices. Aenean in sapien vel mi fringilla scelerisque. Aliquam convallis mi at felis tincidunt, vel tincidunt sem convallis. Maecenas dignissim fringilla augue, vel bibendum velit gravida ac.
          </p>
        </div>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  )
}

export default About